import { render, staticRenderFns } from "./MessageGroupList.vue?vue&type=template&id=39a20bd8"
import script from "./MessageGroupList.vue?vue&type=script&lang=js"
export * from "./MessageGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports